import React from "react";
import { useSelector } from "react-redux";
import { getText } from "../i18n";

const Footer = () => {
  const currentLang = useSelector((state) => state.language.currentLanguage);
  const t = getText(currentLang, "common");

  return (
    <footer className="footer facturize-footer">
      <div className="container-fluid">
        <div className="footer-inner pt-1">
          <span>FACTURIZE © {new Date().getFullYear()}. {t.rights}</span>
          <span>{t.version}: <a href="#">1.0</a></span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
